import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/registerServiceWorker";
import { installMobileViewportFixes } from "@/lib/mobileViewport";
import { initPwaInstall } from "@/lib/pwaInstall";

// Keep --app-height in sync with the real visible viewport (virtual
// keyboard / rotation safe). Must run before first paint of fixed sheets.
installMobileViewportFixes();

// Capture `beforeinstallprompt` BEFORE React mounts — Chrome fires it once,
// often before the install banner component exists. Missing it means the
// "Install app" prompt never appears (see lib/pwaInstall.js).
initPwaInstall();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker. Production-only; silent failure on dev.
registerServiceWorker();
